import { Output, Component, Input, EventEmitter } from "@angular/core";
import { EButtonType } from "../../../data-types/button.enum";
import { iconsLibrary } from "../../../../theme/constants";
import { ISpace } from "../../../data-types/space.interface";
import { CoworkingService } from "../../../services/coworking.service";

@Component({
  selector: "cowing-tag",
  templateUrl: "./cowing-tag.component.html",
  styleUrls: ["./cowing-tag.component.scss"],
})
export class CowingTagComponent {
  @Input('color') color = 'white';
  @Input('background') background = 'black';
  @Input('text') text = 'test'

}
